export const PREFECTURES = [
  { value: '北海道', ja: '北海道', en: 'Hokkaido', th: 'ฮอกไกโด', vi: 'Hokkaido' },
  { value: '青森県', ja: '青森県', en: 'Aomori', th: 'อาโอโมริ', vi: 'Aomori' },
  { value: '岩手県', ja: '岩手県', en: 'Iwate', th: 'อิวาเตะ', vi: 'Iwate' },
  { value: '宮城県', ja: '宮城県', en: 'Miyagi', th: 'มิยางิ', vi: 'Miyagi' },
  { value: '秋田県', ja: '秋田県', en: 'Akita', th: 'อากิตะ', vi: 'Akita' },
  { value: '山形県', ja: '山形県', en: 'Yamagata', th: 'ยามางาตะ', vi: 'Yamagata' },
  { value: '福島県', ja: '福島県', en: 'Fukushima', th: 'ฟุกุชิมะ', vi: 'Fukushima' },
  { value: '茨城県', ja: '茨城県', en: 'Ibaraki', th: 'อิบารากิ', vi: 'Ibaraki' },
  { value: '栃木県', ja: '栃木県', en: 'Tochigi', th: 'โทชิงิ', vi: 'Tochigi' },
  { value: '群馬県', ja: '群馬県', en: 'Gunma', th: 'กุมมะ', vi: 'Gunma' },
  { value: '埼玉県', ja: '埼玉県', en: 'Saitama', th: 'ไซตามะ', vi: 'Saitama' },
  { value: '千葉県', ja: '千葉県', en: 'Chiba', th: 'ชิบะ', vi: 'Chiba' },
  { value: '東京都', ja: '東京都', en: 'Tokyo', th: 'โตเกียว', vi: 'Tokyo' },
  { value: '神奈川県', ja: '神奈川県', en: 'Kanagawa', th: 'คานางาวะ', vi: 'Kanagawa' },
  { value: '新潟県', ja: '新潟県', en: 'Niigata', th: 'นีงาตะ', vi: 'Niigata' },
  { value: '富山県', ja: '富山県', en: 'Toyama', th: 'โทยามะ', vi: 'Toyama' },
  { value: '石川県', ja: '石川県', en: 'Ishikawa', th: 'อิชิกาวะ', vi: 'Ishikawa' },
  { value: '福井県', ja: '福井県', en: 'Fukui', th: 'ฟุกุอิ', vi: 'Fukui' },
  { value: '山梨県', ja: '山梨県', en: 'Yamanashi', th: 'ยามานาชิ', vi: 'Yamanashi' },
  { value: '長野県', ja: '長野県', en: 'Nagano', th: 'นางาโนะ', vi: 'Nagano' },
  { value: '岐阜県', ja: '岐阜県', en: 'Gifu', th: 'กิฟุ', vi: 'Gifu' },
  { value: '静岡県', ja: '静岡県', en: 'Shizuoka', th: 'ชิสึโอกะ', vi: 'Shizuoka' },
  { value: '愛知県', ja: '愛知県', en: 'Aichi', th: 'ไอจิ', vi: 'Aichi' },
  { value: '三重県', ja: '三重県', en: 'Mie', th: 'มิเอะ', vi: 'Mie' },
  { value: '滋賀県', ja: '滋賀県', en: 'Shiga', th: 'ชิงะ', vi: 'Shiga' },
  { value: '京都府', ja: '京都府', en: 'Kyoto', th: 'เกียวโต', vi: 'Kyoto' },
  { value: '大阪府', ja: '大阪府', en: 'Osaka', th: 'โอซากะ', vi: 'Osaka' },
  { value: '兵庫県', ja: '兵庫県', en: 'Hyogo', th: 'เฮียวโงะ', vi: 'Hyogo' },
  { value: '奈良県', ja: '奈良県', en: 'Nara', th: 'นาระ', vi: 'Nara' },
  { value: '和歌山県', ja: '和歌山県', en: 'Wakayama', th: 'วากายามะ', vi: 'Wakayama' },
  { value: '鳥取県', ja: '鳥取県', en: 'Tottori', th: 'ทตโตริ', vi: 'Tottori' },
  { value: '島根県', ja: '島根県', en: 'Shimane', th: 'ชิมาเนะ', vi: 'Shimane' },
  { value: '岡山県', ja: '岡山県', en: 'Okayama', th: 'โอกายามะ', vi: 'Okayama' },
  { value: '広島県', ja: '広島県', en: 'Hiroshima', th: 'ฮิโรชิมะ', vi: 'Hiroshima' },
  { value: '山口県', ja: '山口県', en: 'Yamaguchi', th: 'ยามางุชิ', vi: 'Yamaguchi' },
  { value: '徳島県', ja: '徳島県', en: 'Tokushima', th: 'โทกุชิมะ', vi: 'Tokushima' },
  { value: '香川県', ja: '香川県', en: 'Kagawa', th: 'คางาวะ', vi: 'Kagawa' },
  { value: '愛媛県', ja: '愛媛県', en: 'Ehime', th: 'เอฮิเมะ', vi: 'Ehime' },
  { value: '高知県', ja: '高知県', en: 'Kochi', th: 'โคจิ', vi: 'Kochi' },
  { value: '福岡県', ja: '福岡県', en: 'Fukuoka', th: 'ฟุกุโอกะ', vi: 'Fukuoka' },
  { value: '佐賀県', ja: '佐賀県', en: 'Saga', th: 'ซางะ', vi: 'Saga' },
  { value: '長崎県', ja: '長崎県', en: 'Nagasaki', th: 'นางาซากิ', vi: 'Nagasaki' },
  { value: '熊本県', ja: '熊本県', en: 'Kumamoto', th: 'คุมาโมโตะ', vi: 'Kumamoto' },
  { value: '大分県', ja: '大分県', en: 'Oita', th: 'โออิตะ', vi: 'Oita' },
  { value: '宮崎県', ja: '宮崎県', en: 'Miyazaki', th: 'มิยาซากิ', vi: 'Miyazaki' },
  { value: '鹿児島県', ja: '鹿児島県', en: 'Kagoshima', th: 'คาโงชิมะ', vi: 'Kagoshima' },
  { value: '沖縄県', ja: '沖縄県', en: 'Okinawa', th: 'โอกินาวะ', vi: 'Okinawa' }
];
